<article class="row">
    <div class="col-sm-10 offset-sm-1 col-xl-8 offset-xl-2 card p-4 p-sm-5 text-center">
      <i class="ifc-icon {{errorIcon}} ifc-icon-3 mb-2"></i>
      <h1 class="h2">{{errorHeader | translate}}</h1>
      <p class="lead my-4">{{errorText | translate}}</p><span *ngIf="errorDetails"><a href="#" role="button" data-toggle="collapse" data-target="#result">{{ 'ui.error.more_details' | translate }}</a> </span>

      <div class="row">
        <div id="result" class="collapse col" *ngIf="errorDetails">
          <textarea readonly class="form-control" rows="20" id="resultPage">{{errorDetails}}</textarea>
        </div>
      </div>

      <ng-content></ng-content>

      <button class="btn btn-outline-primary mt-4" (click)="goHome()" *ngIf="!hideGoHome">{{'ui.error.return_home' | translate}}</button>
    </div>
  </article>
